import { useMediaQuery } from "@mui/material";
import { useExtendedTheme } from "@theme/Context";

export const useIsDesktop = () => {
  const { theme } = useExtendedTheme();
  return useMediaQuery(theme.breakpoints.up("md"));
};
